<template>
    <div v-if="!getMemes" class="grid" ref="socialfeed">Getting Social Feed...</div>
    <div v-else >
     
        <div class="grid card__cards-wrapper">
          <div v-for="index in memesToShow" :key="index" class="card__wrapper" v-if="memes[index]">
              <div class="card__image--large" v-if="memes[index].mediaUrl">
                <img alt="" :src="generateMediaUrl(memes[index].mediaUrl)" class="card__image">
              </div>
              <div class="card__body">
                <div class="card__label">{{ memes[index].displayName }}</div> 
                <p class="card__copy" v-html="truncateText(memes[index].text, 100)"></p> 
                <a :href="memes[index].link" class="cta__standard" rel="noreferrer noopener" target="_blank">
                  <span class="cta__copy">Visit Post</span> 
                  <span class="cta__arrow cta__arrow--external">
                    <svg viewBox="0 0 13.75 12.16" xmlns:xlink="http://www.w3.org/1999/xlink" class="arrow-icon">
                      <use xlink:href="/o/udliferay-theme/images/symbols/arrow-icon.svg#arrow-icon"></use>
                    </svg>
                  </span>
                </a>
              </div>            
          </div>
        </div>
    
    </div>
</template>
<script>
import axios from 'axios';

export default {
    name: 'SocialFeed',
    props: {
        id: {
            type: String,
            required: true,
        },
        number: {
            type: Number,
            required: true,
        },
        columns: {
            type: Number,
            default: 3,
        }
    },
    data() {
        return {
            memes: [],
            getMemes: undefined,
        };
    },
    computed: {
      memesToShow: function () {
        var rval = [];
        for (var i = 0; i < this.number; i++) {
          rval.push(i);
        }
        return rval;
      }
    },
    mounted() {

        const self = this;

        var url = '';
        if(process.env.NODE_ENV === 'development'){
            url = `https://bruce-qa.udayton.edu/social/posts/feed/${self.id}/byCreationDesc`;
        } else {
            url = `https://bruce.udayton.edu/social/posts/feed/${self.id}/byCreationDesc`;
        }

        var xhr = new XMLHttpRequest();

        xhr.onreadystatechange = function() {
          if (xhr.readyState === 4) {
            self.memes = xhr.response;
            //setting template variable to confirm memes have been retrieved
            self.getMemes = "memes";
                   
          }
        }

        xhr.open('GET', url, true);
        xhr.responseType = 'json';

        xhr.send('');

        self.checkFlexMasonry(); 
    },
   methods: {
      truncateText: function(text, max){

        return text.substr(0,max-1)+(text.length>max?' …':''); 

      },
      generateMediaUrl: function(url) {
        return "/_udayton/php/utilities/img.php?i=" + url;
      },
      checkFlexMasonry: function () {
           var self = this;
           var clearCheckMasonry;
           var columns = 3;
           
           if (typeof FlexMasonry != "undefined" && this.getMemes != undefined)
               {
                 FlexMasonry.init('.grid', {
                    responsive: true,
                    breakpointCols: {
                        'min-width: 992px': columns,
                        'min-width: 511px': columns-1, 
                        'min-width: 1px': columns-2,
                    },
                    numCols: columns,
                 });

                 clearTimeout(clearCheckMasonry);

           } else {
              clearCheckMasonry = setTimeout(self.checkFlexMasonry,500);
           }
      }

   },
};
</script>




<style lang="scss">
.flexmasonry-container {
    overflow-x: hidden;
}
.flexImage {
    padding: 2px;
}
.flexText {
    padding: 2px;
    @include content-body;
}
.flexmasonry {
    display: flex;
    flex-flow: column wrap;
    align-content: space-between;
}

.flexmasonry-item { width: 100%; }
.flexmasonry-cols-2 .flexmasonry-item { width: 50%; }
.flexmasonry-cols-3 .flexmasonry-item { width: 33.333%; }
.flexmasonry-cols-4 .flexmasonry-item { width: 25%; }
.flexmasonry-cols-5 .flexmasonry-item { width: 20%; }
.flexmasonry-cols-6 .flexmasonry-item { width: 16.666%; }
.flexmasonry-cols-7 .flexmasonry-item { width: 14.285%; }
.flexmasonry-cols-8 .flexmasonry-item { width: 12.5%; }

.flexmasonry-cols-2 .flexmasonry-item:nth-child(2n+1) { order: 1; }
.flexmasonry-cols-2 .flexmasonry-item:nth-child(2n)   { order: 2; }

.flexmasonry-cols-3 .flexmasonry-item:nth-child(3n+1) { order: 1; }
.flexmasonry-cols-3 .flexmasonry-item:nth-child(3n+2) { order: 2; }
.flexmasonry-cols-3 .flexmasonry-item:nth-child(3n)   { order: 3; }

.flexmasonry-cols-4 .flexmasonry-item:nth-child(4n+1) { order: 1; }
.flexmasonry-cols-4 .flexmasonry-item:nth-child(4n+2) { order: 2; }
.flexmasonry-cols-4 .flexmasonry-item:nth-child(4n+3) { order: 3; }
.flexmasonry-cols-4 .flexmasonry-item:nth-child(4n)   { order: 4; }

.flexmasonry-cols-5 .flexmasonry-item:nth-child(5n+1) { order: 1; }
.flexmasonry-cols-5 .flexmasonry-item:nth-child(5n+2) { order: 2; }
.flexmasonry-cols-5 .flexmasonry-item:nth-child(5n+3) { order: 3; }
.flexmasonry-cols-5 .flexmasonry-item:nth-child(5n+4) { order: 4; }
.flexmasonry-cols-5 .flexmasonry-item:nth-child(5n)   { order: 5; }

.flexmasonry-cols-6 .flexmasonry-item:nth-child(6n+1) { order: 1; }
.flexmasonry-cols-6 .flexmasonry-item:nth-child(6n+2) { order: 2; }
.flexmasonry-cols-6 .flexmasonry-item:nth-child(6n+3) { order: 3; }
.flexmasonry-cols-6 .flexmasonry-item:nth-child(6n+4) { order: 4; }
.flexmasonry-cols-6 .flexmasonry-item:nth-child(6n+5) { order: 5; }
.flexmasonry-cols-6 .flexmasonry-item:nth-child(6n)   { order: 6; }

.flexmasonry-cols-7 .flexmasonry-item:nth-child(7n+1) { order: 1; }
.flexmasonry-cols-7 .flexmasonry-item:nth-child(7n+2) { order: 2; }
.flexmasonry-cols-7 .flexmasonry-item:nth-child(7n+3) { order: 3; }
.flexmasonry-cols-7 .flexmasonry-item:nth-child(7n+4) { order: 4; }
.flexmasonry-cols-7 .flexmasonry-item:nth-child(7n+5) { order: 5; }
.flexmasonry-cols-7 .flexmasonry-item:nth-child(7n+6) { order: 6; }
.flexmasonry-cols-7 .flexmasonry-item:nth-child(7n)   { order: 7; }

.flexmasonry-cols-8 .flexmasonry-item:nth-child(8n+1) { order: 1; }
.flexmasonry-cols-8 .flexmasonry-item:nth-child(8n+2) { order: 2; }
.flexmasonry-cols-8 .flexmasonry-item:nth-child(8n+3) { order: 3; }
.flexmasonry-cols-8 .flexmasonry-item:nth-child(8n+4) { order: 4; }
.flexmasonry-cols-8 .flexmasonry-item:nth-child(8n+5) { order: 5; }
.flexmasonry-cols-8 .flexmasonry-item:nth-child(8n+6) { order: 6; }
.flexmasonry-cols-8 .flexmasonry-item:nth-child(8n+7) { order: 7; }
.flexmasonry-cols-8 .flexmasonry-item:nth-child(8n)   { order: 8; }

.flexmasonry-break {
    content: "";
    flex-basis: 100%;
    width: 0 !important;
    margin: 0;
}
.flexmasonry-break-1 { order: 1; }
.flexmasonry-break-2 { order: 2; }
.flexmasonry-break-3 { order: 3; }
.flexmasonry-break-4 { order: 4; }
.flexmasonry-break-5 { order: 5; }
.flexmasonry-break-6 { order: 6; }
.flexmasonry-break-7 { order: 7; }


.flexmasonry-item .card__label {
    text-transform: uppercase;
}

.flexmasonry-item {
    padding: 10px;
}

.flexmasonry-item .card__body {
    padding: 20px 15px 10px 15px;
}

.flexmasonry-container .card__container {
    padding-top: 10px;
    background-color: #f0F0f0;
}

</style>


// WEBPACK FOOTER //
// src/components/SocialFeed.vue